module.exports = "/text-sent4b5123670dabc4955b0467b7d0b3c699.svg";